<template>
  <v-card class="page">
    <div :style="styles" id="page_wrapper">
      <div class="flexRow align-center" style="width: 94%" v-if="defaultBanner">
        <img :src="branch_logo" alt="SO" class="branch_logo" />
        <div class="flex-column text-xs-center" style="flex: 1">
          <div
            class="xs12"
            style="
              font-weight: 700;
              font-size: 18px !important;
              margin-top: 20px;
            "
          >
            {{ branch_fa_name }}
          </div>
          <div class="xs12 font-weight-bold py-1" style="font-size:18px">
            {{ LONG_APP_NAME }}
          </div>
          <!-- <div class="title xs12 font-weight-bold">
            {{ branch_fa_name }}
          </div> -->
          <div class="body-2 font-weight-bold">
            ( {{ brnch_name || userBranch.name }} )
          </div>
          <div class="pt-2 font-weight-bold">{{ title }}</div>
          <div class="pt-1 font-weight-medium">{{ sub_title }}</div>
          <div class="pb-2 pt-1 font-weight-medium" v-if="second_sub_title">
            {{ second_sub_title }}
          </div>
        </div>
        <!-- <img :src="APP_LOGO" alt="SO" class="branch_logo" /> -->
        <div class="branch_logo">
          <!-- <slot name="right"></slot> -->
        </div>
        <!-- <v-avatar class="logo" tile :size="126"></v-avatar> -->
      </div>
      <slot name="banner" v-else></slot>
      <table class="printTable" id="section-to-print">
        <thead>
          <slot name="header"></slot>
        </thead>
        <tbody>
          <slot name="body"></slot>
        </tbody>
        <tfoot>
          <slot name="footer"></slot>
        </tfoot>
        <!-- <v-footer
          absolute
          bottom
          class="px-3 mb-1 font-weight-bold border di-flex justify-space-between"
        >
          <span>{{ company_email }}</span>
          <span>{{ company_address }}</span>
          <span>{{ company_phones.join(" - ") }}</span>
        </v-footer>-->
      </table>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    styles: {
      default: { "min-height": "297mm", width: "200mm" },
    },
    defaultBanner: {
      default: true,
    },
    title: {
      default: "",
    },
    sub_title: {
      default: "",
    },
    second_sub_title: {
      default: "",
    },
    brnch_name: {
      default: false,
    },
  },
};
</script>

<style>
.branch_logo {
  width: 20mm;
  height: auto;
}

#page_wrapper {
  display: flex;
  padding-top: 20px;
  align-items: center;
  padding-bottom: 20px;
  flex-direction: column;
}

table.printTable {
  border-collapse: collapse;
  width: 94%;
}

table.printTable tr,
table.printTable td {
  font-size: 11px;
  padding: 3px 5px;
  text-align: center;
  /* font-family: "IR_M"; */
  vertical-align: middle;
  border: 1px solid black;
}

.wrap-text td {
  word-break: break-all;
}

@media print {
  table {
    page-break-after: avoid;
  }

  @-moz-document url-prefix() {
    body {
      display: block;
    }
  }
  tr {
    page-break-inside: avoid;
    /* page-break-after: always; */
  }

  td {
    page-break-after: auto;
  }

  tbody {
    display: table-row-group;
  }

  thead {
    padding-top: 20px;
    display: table-header-group;
  }

  tfoot {
    display: table-footer-group;
  }

  .page {
    box-shadow: none !important;
    padding-bottom: 0;
    margin-bottom: 0;
  }

  #page_wrapper {
    padding: 0;
  }
}
</style>